import http from '../http-common'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { AutocompleteShape, Role } from '@types'

const responseBody = (response: AxiosResponse) => response.data

const requests = {
	get: (url: string, config?: AxiosRequestConfig) => http.get(url, config).then(responseBody),
	post: (url: string, config: Role) =>
		http
			.post(url, config)
			.then(responseBody)
			.catch((error) => {
				return Promise.reject(error)
			}),
	delete: (url: string) => http.delete(url).then(responseBody)
}

export const roleService = {
	getRoles: (params: any): Promise<any> => requests.get('/roles', { params: params }),
	deleteRole: (params: string): Promise<any> => requests.delete(`roles/delete/${params}`),
	createRole: (role: Role): Promise<void> =>
		requests.post('roles/create', role).catch((error) => {
			return Promise.reject(error)
		}),
	editRole: (role: any): Promise<any> => requests.post('roles/edit', role),
	getAutocomplete: (params: any): Promise<AutocompleteShape[]> => requests.get('', { params: params }),
	getRolesAutocomplete: (): Promise<AutocompleteShape[]> => requests.get('roles/roles-dropdown-list'),
	getRolesForRoleGroup: (params: any): Promise<any> =>
		requests.get('roles/roles-role-group-dropdown-list', { params: params })
}
